import React, { useCallback, useEffect, useState } from "react";
import s from './MyPressButton.module.css';

export default function MyPressButton({isPressed, clickedAction, bText, myRef, isLoading, overrideStyle}) {	
	return (<div ref={myRef} className={s.default + ((isPressed) ? " " + s.isPressed : "")} style={overrideStyle} onClick={clickedAction}>
		<div>
			{bText}
		</div>
	</div>)
}

export function MyGreenPressButton({isPressed, clickedAction, bText, myRef, isLoading, overrideStyle}) {	
	return (<div ref={myRef} className={s.greendefault + ((isPressed) ? " " + s.greenisPressed : "")} style={overrideStyle} onClick={clickedAction}>
		<div>
			{bText}
		</div>
	</div>)
}

export function MyCirclePressButton({isPressed, clickedAction, bText, myRef, isLoading, overrideStyle}) {	
	return (
		<div ref={myRef} className={s.circledefault + ((isPressed) ? " " + s.circleisPressed : "")} style={overrideStyle} onClick={clickedAction}>
	</div>)
}